import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetTitle,
} from '@/components/ModalSheet'
import styles from './TermsModal.module.css'
import { Button } from '@/components/Button'

export interface TermsModalProps {
  showing: boolean
  termsContent: string
  onAccept: () => unknown
  isAcceptPending: boolean
}

export function TermsModal({
  showing,
  termsContent,
  onAccept,
  isAcceptPending,
}: TermsModalProps) {
  return (
    <ModalSheet showing={showing} disableCloseOnEsc disableCloseOnOutsideClick>
      <ModalSheetHeader bordered>
        <ModalSheetTitle>Terms Of Use</ModalSheetTitle>
      </ModalSheetHeader>
      <ModalSheetContent>
        <div
          className={styles.termsFrameContent}
          dangerouslySetInnerHTML={{ __html: termsContent }}
        />
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Accept"
            onPress={onAccept}
            isPending={isAcceptPending}
            variant="primary"
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
